import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20e3078f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex w-full justify-between" }
const _hoisted_2 = { class: "logo flex justify-start" }
const _hoisted_3 = { class: "buttons cursor-pointer" }
const _hoisted_4 = { class: "w-full steps flex justify-center mt-5" }
const _hoisted_5 = { class: "w-full flex gap-2 items-center justify-center flex-col rounded overflow-hidden my-10" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-center font-bold text-2xl mb-7" }, "Cadastro realizado com sucesso!", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "subtitle" }, "Clique para abrir o aplicativo!", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_close_icon = _resolveComponent("close-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_user_data = _resolveComponent("user-data")!
  const _component_professional_data = _resolveComponent("professional-data")!
  const _component_Address = _resolveComponent("Address")!
  const _component_personal_data = _resolveComponent("personal-data")!
  const _component_AppStoreBadges = _resolveComponent("AppStoreBadges")!
  const _component_steps = _resolveComponent("steps")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.classMainContainer)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Logo, {
          width: "200px",
          logo: "horizontal"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.disableDefaultCloseCallback)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCloseSignupForm && _ctx.onCloseSignupForm(...args)))
            }, [
              _createVNode(_component_close_icon)
            ]))
          : _createCommentVNode("", true),
        (_ctx.disableDefaultCloseCallback)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: "/signup"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_close_icon)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_steps, {
        onChangeStep: _ctx.changeStep,
        onFinish: _ctx.goToLogin,
        stepSelected: _ctx.stepSelected,
        stepsLength: 5,
        title: "Cadastro Médico"
      }, {
        "step-0": _withCtx(() => [
          _createVNode(_component_user_data)
        ]),
        "step-1": _withCtx(() => [
          _createVNode(_component_professional_data)
        ]),
        "step-2": _withCtx(() => [
          _createVNode(_component_Address)
        ]),
        "step-3": _withCtx(() => [
          _createVNode(_component_personal_data)
        ]),
        "step-4": _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createVNode(_component_AppStoreBadges, {
              "android-url": _ctx.androidUrl,
              "ios-url": _ctx.iosUrl
            }, null, 8, ["android-url", "ios-url"])
          ])
        ]),
        footer: _withCtx(() => []),
        _: 1
      }, 8, ["onChangeStep", "onFinish", "stepSelected"])
    ])
  ], 2))
}